import React from "react";
import Switch from "react-switch";

import "./rewards.scss";
import CoinImg from "../../assets/coin.png";

const Rewards = ({ coins, handleChange, checked }) => {
  return (
    <div className="rewards-section">
      <div className="reward-left">
        <img src={CoinImg} className="coinStyle" alt="reward coin" />
        <span className="reward-text">
          Use <span>&#8377;</span>
          {coins} Rewards
        </span>
      </div>
      <div className="reward-right">
        <Switch
          onChange={handleChange}
          checked={checked}
          className="switch"
          onColor="#27374D"
          uncheckedIcon={false}
          checkedIcon={false}
        />
      </div>
    </div>
  );
};

export default Rewards;
